import React, { FC } from "react";
import { TeamName } from "../../../../../Components/TeamName";
import { Grid } from "@mantine/core";
import { IconBallFootball } from "@tabler/icons-react";
import { useShootoutDisplay } from "../../../../../hooks/useShootoutDisplay";
import { useGame } from "../../../../../hooks/useGame";

const teamNameStyle: React.CSSProperties = {
  fontSize: 76,
  lineHeight: "76px",
  fontWeight: 700,
};

interface DisplayShootoutProps {
  gameId: string;
}

export const DisplayShootout: FC<DisplayShootoutProps> = (props) => {
  const { gameId } = props;

  const game = useGame(gameId);
  const shootout = useShootoutDisplay(gameId);

  const homeTeamId = game.data?.actualTeams.homeTeamId;
  const guestTeamId = game.data?.actualTeams.guestTeamId;

  if (!game.isSuccess || !homeTeamId || !guestTeamId || !shootout) {
    return <></>;
  }

  const { homeShots, guestShots } = shootout;

  const homeTeamShots = homeShots.map((success, i) => (
    <IconBallFootball
      key={i}
      color={success !== null ? (success ? "#00e64d" : "red") : "#888"}
      size={65}
    />
  ));

  const guestTeamShots = guestShots.map((success, i) => (
    <IconBallFootball
      key={i}
      color={success !== null ? (success ? "#00e64d" : "red") : "#888"}
      size={65}
    />
  ));

  return (
    <>
      <div
        style={{
          padding: 15,
        }}
      >
        <Grid>
          <Grid.Col span={8}>
            <Grid>
              <Grid.Col span={3} style={teamNameStyle}>
                <TeamName short teamId={homeTeamId} />
              </Grid.Col>
              <Grid.Col span={9}>
                <div style={{ paddingTop: 5 }}>{homeTeamShots}</div>
              </Grid.Col>
            </Grid>
            <Grid>
              <Grid.Col span={3} style={teamNameStyle}>
                <TeamName short teamId={guestTeamId} />
              </Grid.Col>
              <Grid.Col span={9}>
                <div style={{ paddingTop: 5 }}>{guestTeamShots}</div>
              </Grid.Col>
            </Grid>
          </Grid.Col>
          <Grid.Col
            span={4}
            style={{
              fontSize: 175,
              lineHeight: "155px",
              textAlign: "right",
              fontWeight: 700,
            }}
          >
            {
              game.data.shootOutShots.filter(
                (s) => s.teamId === homeTeamId && s.success,
              ).length
            }
            :
            {
              game.data.shootOutShots.filter(
                (s) => s.teamId === guestTeamId && s.success,
              ).length
            }
          </Grid.Col>
        </Grid>
      </div>
    </>
  );
};
